import React from "react";
import "./paraTextBlock.scss";
import classNames from "classnames";
import { graphql } from "gatsby";
import ExtractRichText from "../../molecules/ExtractRichText";
import { getParagraph } from "../../../utils/paragraphHelpers";
import { getContrastColor } from "../../../utils/miscUtils";

//Full Width means within container
//Edge to Edge means - Full bleed

const LAYOUT = {
  CONTAINED_WIDTH : 'full',
  FULL_BLEED : 'edge2edge',
}

export const ParagraphParagraphTextBlock = ({ node }) => {
  const {
    field_background_color,
    field_paragraph_body,
    field_paragraph_title,
    field_width,
  } = node;

  let containerClasses = classNames(
    "paragraph-text-block",

    {
      "w-90 w-md-100":
        (field_background_color && field_background_color !== "white") ||
        field_width === LAYOUT.CONTAINED_WIDTH,
    },

    { "general-container container": field_width === LAYOUT.CONTAINED_WIDTH || !field_width },
    { "no-border-radius w-100": field_width === LAYOUT.FULL_BLEED },

    field_background_color ? `bg-clr-${field_background_color}` : "",

    { "px-3 p-0": !field_background_color },
    { "py-0": field_background_color === "white" },
    { "text-white": field_background_color === "regalBlue" } //in future, check if this line can be replaced with getContrastColor func.
  );

  let wrapperClasses = classNames({
    // to prevent text of Para Text Block to expand when the Entire Para Text Block is full bleed.
    "general-container container": field_width === LAYOUT.FULL_BLEED,
  });

  let headingExtraClasses = classNames(
    "mb-4 paragraph-text-block__title",
    `color-${getContrastColor(field_background_color)}`
  );

  const paragraphs = node?.relationships?.field_cta_links?.map(getParagraph);

  return (
    <div className={containerClasses}>
      <div className={wrapperClasses}>
        {field_paragraph_title && (
          <h2 className={headingExtraClasses}>{field_paragraph_title}</h2>
        )}
        {field_paragraph_body && (
          <ExtractRichText
            richText={field_paragraph_body?.value}
            extraClasses={"w-100"}
          />
        )}

        {paragraphs && paragraphs?.length > 0 && (
          <div className="cta-wrapper">{paragraphs}</div>
        )}
      </div>
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphParagraphTextBlock on paragraph__paragraph_text_block {
    field_background_color
    id
    field_paragraph_body {
      value
    }
    field_width
    field_paragraph_title
    relationships {
      field_cta_links {
        type: __typename
        ...ParagraphLinks
      }
    }
  }
`;

export default ParagraphParagraphTextBlock;
